import { BaseReducer } from '@hobs/utils/baseReducer';
import { GET, CLEAR, FORSUBMIT } from '@hobs/constants/subcontractor';

class Subcontractor extends BaseReducer {
  static defaultState = {
    subcontractor: {},
    subcontractorForSubmit: {}
  };

  constructor() {
    super(Subcontractor.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.getSubcontractor,
      [CLEAR.SUCCESS]: this.clearSubcontractor,
      [FORSUBMIT.SUCCESS]: this.getSubcontractorForSubmit
    };
  }

  getSubcontractor = (state, action) => {
    return Object.assign({}, state, {
      subcontractor: action.response
    });
  };

  clearSubcontractor = state => {
    return Object.assign({}, state, { subcontractor: {} });
  };

  getSubcontractorForSubmit = (state, action) => {
    return Object.assign({}, state, {
      subcontractorForSubmit: action.response
    });
  };
}

export default new Subcontractor().reducer;
